<template>
  <div class="col-sm-12 col-lg-6">
    <div class="card">
      <div class="card-header" :class="emphasisClass" v-if="emphasisClass" />

      <div class="card-body">
        <div v-if="id === 'production_data_ready'">
          <h4 class="card-title">
            {{ $t('ProjectCards.production_data_ready.title') }}
          </h4>
          <p class="card-text">
            {{ $t('ProjectCards.production_data_ready.description') }}
          </p>

          <div v-if="$store.state.board.orderable">
            <a :href="additionals.checkoutPath" class="btn btn-aisler-gradient checkout-btn w-100 mb-3">
              {{ $t('ProjectCards.production_data_ready.checkout', additionals) }}
            </a>
          </div>

          <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center">
              <img
                src="~images/locale/eu_small.svg"
                class="inline-flag"
                :alt="$t('ProjectCards.production_data_ready.euFlag')"
              >
              &nbsp;{{ $t('ProjectCards.production_data_ready.madeInEurope') }}
            </div>
            <div>
              <a
                :href="additionals.boardPath"
                class="card-link"
              >
                {{ $t('ProjectCards.production_data_ready.open_board_inspector') }}
              </a>
            </div>
          </div>
        </div>
        <div v-if="id === 'production_data_failed'">
          <h4 class="card-title">
            {{ $t('ProjectCards.production_data_failed.title') }}
          </h4>
          <p class="card-text">
            {{ $t('ProjectCards.production_data_failed.description') }}
            <a :href="additionals.newSupportPath">
              {{ $t('ProjectCards.production_data_failed.link') }}
            </a>
          </p>
          <div class="text-end">
            <a
              class="card-link"
              @click="executeAction"
              data-action="add_revision"
              href="#"
            >
              {{ $t('ProjectCards.production_data_failed.add_new_revision') }}
            </a>
          </div>
        </div>
        <div v-if="id === 'critical_processing_notes'">
          <h4 class="card-title">
            {{ $t('ProjectCards.critical_processing_notes.title') }}
          </h4>
          <p class="card-text">
            {{ $t('ProjectCards.critical_processing_notes.description') }}
          </p>
          <a
            :href="additionals.boardPath"
            class="btn btn-aisler-gradient checkout-btn w-100 mb-3"
          >
            {{ $t('ProjectCards.critical_processing_notes.link') }}
          </a>
          <div class="text-end">
            <a
              class="card-link"
              @click="executeAction"
              data-action="add_revision"
              href="#"
            >
              {{ $t('ProjectCards.critical_processing_notes.add_new_revision') }}
            </a>
          </div>
        </div>
        <div v-if="id === 'blocking_processing_notes'">
          <h4 class="card-title">
            {{ $t('ProjectCards.blocking_processing_notes.title') }}
          </h4>
          <p class="card-text">
            {{ $t('ProjectCards.blocking_processing_notes.description') }}
          </p>
          <div class="text-end">
            <a
              :href="additionals.boardPath"
              class="card-link"
            >
              {{ $t('ProjectCards.blocking_processing_notes.link') }}
            </a>
          </div>
        </div>
        <div v-if="id === 'mistake'">
          <h4 class="card-title">
            {{ $t('ProjectCards.mistake.title') }}
          </h4>
          <p class="card-text">
            {{ $t('ProjectCards.mistake.description') }}
          </p>
          <div class="text-end">
            <a
              class="card-link"
              @click="executeAction"
              data-action="add_revision"
              href="#"
            >
              {{ $t('ProjectCards.mistake.add_new_revision') }}
            </a>
          </div>
        </div>
        <div v-if="id === 'running_order_revision'">
          <h4 class="card-title">
            {{ $t('ProjectCards.running_order_revision.title') }}
          </h4>
          <p class="card-text">
            {{ $t('ProjectCards.running_order_revision.description') }}
          </p>
          <div class="text-end">
            <a
              :href="additionals.newSupportPath"
              class="card-link"
            >
              {{ $t('ProjectCards.running_order_revision.contact_us') }}
            </a>
          </div>
        </div>
        <div v-if="id === 'start_blank'">
          <h4 class="card-title">
            {{ $t('ProjectCards.start_blank.title') }}
          </h4>
          <p class="card-text">
            {{ $t('ProjectCards.start_blank.description') }}
          </p>
          <div class="text-end">
            <a
              class="card-link link-primary"
              @click="executeAction"
              data-action="start_over"
              href="#"
            >
              {{ $t('ProjectCards.start_blank.start_blank_project') }}
            </a>
          </div>
        </div>
        <div v-if="id === 'sharing'">
          <h4 class="card-title">
            {{ $t('ProjectCards.sharing.title') }}
          </h4>
          <p class="card-text">
            {{ $t('ProjectCards.sharing.description') }}
          </p>
          <div class="text-end">
            <a
              class="card-link"
              data-bs-toggle="modal"
              data-bs-target="#sharingModalContent"
              href="#"
            >
              {{ $t('ProjectCards.sharing.open_sharing_preferences') }}
            </a>
          </div>
        </div>
        <div v-if="id === 'admin_revision'">
          <h4 class="card-title">
            {{ $t('ProjectCards.admin_revision.title') }}
          </h4>
          <p class="card-text">
            {{ $t('ProjectCards.admin_revision.description') }}
          </p>
          <div class="text-end">
            <a
              class="card-link"
              @click="executeAction"
              data-action="add_revision"
              href="#"
            >
              {{ $t('ProjectCards.admin_revision.add_new_revision') }}
            </a>
          </div>
        </div>
        <div v-if="id === 'last_minute'">
          <h4 class="card-title">
            {{ $t('ProjectCards.last_minute.title') }}
          </h4>
          <p
            class="card-text"
            v-html="$t('ProjectCards.last_minute.description')"
          />
          <div class="text-end">
            <a
              class="card-link"
              @click="executeAction"
              data-action="add_revision"
              href="#"
            >
              {{ $t('ProjectCards.last_minute.add_new_revision') }}
            </a>
          </div>
        </div>
        <div v-if="id === 'iterate'">
          <h4 class="card-title">
            {{ $t('ProjectCards.iterate.title') }}
          </h4>
          <p class="card-text">
            {{ $t('ProjectCards.iterate.description') }}
          </p>
          <div class="text-end">
            <a
              class="card-link"
              @click="executeAction"
              data-action="add_revision"
              href="#"
            >
              {{ $t('ProjectCards.iterate.add_new_revision') }}
            </a>
          </div>
        </div>
        <div v-if="id === 'smart_tests'">
          <h4 class="card-title">
            {{ $t('ProjectCards.smart_tests.title') }}
          </h4>
          <p class="card-text">
            {{ $t('ProjectCards.smart_tests.description') }}
          </p>
          <div style="display: flex; flex-flow: row; align-items: center">
            <i
              class="fas fa-exclamation-triangle"
              style="
                color: #ff4e64;
                padding-right: 1rem;
                font-size: 3rem"
            />
            <div>
              {{ $t('ProjectCards.smart_tests.something_off') }}
            </div>
          </div>
          <div class="text-end">
            <a
              :href="additionals.smartTestsPath"
              class="card-link"
            >
              {{ $t('ProjectCards.smart_tests.link') }}
            </a>
          </div>
        </div>
        <div v-if="id === 'admin_save'">
          <h4 class="card-title">
            {{ $t('ProjectCards.admin_save.title') }}
          </h4>
          <p class="card-text">
            {{
              $t('ProjectCards.admin_save.description',
                 { orgName: this.additionals.orgName, repoName: this.additionals.repoName })
            }}
          </p>
          <div class="text-end">
            <a
              class="card-link"
              @click="executeAction"
              data-action="save_project"
              href="#"
            >
              {{ $t('ProjectCards.admin_save.save_project') }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import messages from 'locales/ProjectCards';
import { putRequest, deleteRequest } from 'helper/request';
import { useConfirmModal } from '../helper/useConfirmModal';

export default {
  data() {
    return {
      visible: true,
    };
  },
  props: {
    id: String,
    emphasis: String,
    additionals: Object,
  },
  setup() {
    const { askForConfirmation } = useConfirmModal();
    return { askForConfirmation };
  },
  computed: {
    emphasisClass() {
      if (!this.emphasis) {
        return null;
      }

      return `text-bg-${this.emphasis}`;
    },
  },
  mounted() {
    this.$el.querySelectorAll('[data-action]').forEach((element) => {
      element.addEventListener('click', () => this.executeAction(element.dataset.action));
    });
  },
  methods: {
    hide() {
      this.visible = false;
    },
    async executeAction(action) {
      if (!(typeof action === 'string')) {
        return;
      }

      if (action.match(/^\//)) {
        window.open(action);
      } else if (action === 'start_over') {
        const confirmed = await this.askForConfirmation({
          title: this.$t('ProjectCards.startOverModal.title'),
          message: this.$t('ProjectCards.startOverModal.message'),
          confirmButtonClass: 'btn-outline-danger',
        })

        if (confirmed) {
          const data = await deleteRequest(window.location.href);
          if (data.location) window.location.href = data.location;
        }
      } else if (action === 'add_revision') {
        document.getElementById('uploadPicker').click();
      } else if (action === 'save_project') {
        const data = await putRequest(window.location.href, { data: { save_project: true } });
        if (data.location) window.location.href = data.location;
      }
    },
  },
  i18n: { messages },
};
</script>

<style></style>
